import { useState, useEffect } from "react";
import Style from "../../Plans/PlansDetailStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../../services/api";
import PageTitle from "../../../components/PageTitle";
import InfoModal from "../../../shared/Bootstrap/InfoModal";

export default function EnterpriseTextConfigPage(props) {

  const [contactTitle, setContactTitle] = useState("");
  const [contactDescription, setContactDescription] = useState("");
  const [notesTitle, setNotesTitle] = useState("");
  const [notesDescription, setNotesDescription] = useState("");

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    LoadEnterpriseInfo();
  }, []);

  async function LoadEnterpriseInfo() {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/textConfigs/${enterpriseId}`);
      if (!result.data.success) {
        setErrorMessage("Não foi possível carregar os dados da página " + (result.data.message ?? ""));
        return;
      }
      if (result.data.success) {
        setErrorMessage("");
        const enterpriseTextConfigs = result.data.enterpriseTextConfigs;
        setContactTitle(enterpriseTextConfigs.contactTitle);
        setContactDescription(enterpriseTextConfigs.contactDescription);
        setNotesTitle(enterpriseTextConfigs.notesTitle);
        setNotesDescription(enterpriseTextConfigs.notesDescription);
      }
    } catch (error: any) {
      console.error("Erro consultando dados de configuração de texto: ", error);
      setErrorMessage("Não foi possível carregar os dados da página: " + error.message);
    }
    finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      onClosePopup();
      const options: AxiosRequestConfig = {};
      const data = {
        contactTitle : contactTitle,
        contactDescription: contactDescription,
        notesTitle: notesTitle,
        notesDescription: notesDescription,
        
      };
      await (api.put(`/enterprises/textConfigs/${enterpriseId}`, data, options));
      setErrorMessage("");
      await LoadEnterpriseInfo();
      setShowSuccessPopup(true);
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message)
    }
    finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }
  function onClosePopup() {
    setShowPopup(false);
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Planta editada com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  return (
    <Style className="default-page">
      <PageTitle title="Detalhes da Planta" />
      {ShowSuccessPopup()}
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={false}
        title="Editar Página"
        body="Você tem certeza que deseja editar esta página?"
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => OnSubmit()}
        primaryDisabled={loading}
      />
      <div className="default-page">
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary return-button">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main className="default-main">
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); OnSubmit(); }}>
              <h2>Edição de Página de Informação</h2>
              <div>
                <label>Titulo do Fale Conosco:</label>
                <input
                  type="text"

                  disabled={loading}
                  defaultValue={contactTitle}
                  onChange={e => setContactTitle(e.target.value)}
                />
              </div>
              <div>
                <label>Descrição do Fale Conosco::</label>
                <textarea

                  disabled={loading}
                  defaultValue={contactDescription}
                  onChange={e => setContactDescription(e.target.value)}
                  cols={60}
                />
              </div>
              <div>
                <label>Titulo do Notas Gerais</label>
                <input
                  type="text"

                  disabled={loading}
                  defaultValue={notesTitle}
                  onChange={e => setNotesTitle(e.target.value)}
                />
              </div>
              <div >
                <label>Descrição:</label>
                <div>
                  <textarea

                    disabled={loading}
                    defaultValue={notesDescription}
                    onChange={e => setNotesDescription(e.target.value)}
                    cols={60}
                  />
                </div>
              </div>

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => { e.preventDefault(); onOpenPopUp(); }}>
                Editar
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  )
}
